import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Person } from 'src/app/lem/models/person/person';
import {PaginatedResponse} from '../../../../models/common/paginated-response';
import {Observable} from 'rxjs';
import { PersonType } from 'src/app/lem/models/person/person-type';

@Component({
  selector: 'app-person-list',
  templateUrl: './person-list.component.html',
  styleUrls: ['./person-list.component.css']
})
export class PersonListComponent implements OnInit {

  constructor() { }

  @Input() personTypes: PersonType[];
  @Input() personList : Person[];
  @Output() deletePerson = new EventEmitter<Person>();
  @Output() editPerson = new EventEmitter<Person>();

  ngOnInit() {



  }

  onDeletePerson (person : Person) {
    this.deletePerson.emit(person);
  }
  onEditPerson (person : Person) {
    this.editPerson.emit(person);
  }

  getTypeValue(type: string){
    return this.personTypes?.find(el => el.id == type).name;
  }
}
